import type { CashAndBankRepository } from "../repositories/CashAndBankRepository";
import type { AllBankAccountsEntity } from "../entities/AllBankAccountsEntity";

export class GetAllBankAccountsUseCase {
  constructor(private readonly repository: CashAndBankRepository) {}

  async execute(): Promise<AllBankAccountsEntity> {
    return this.repository.getAllAccounts();
  }
}
